// extracted by mini-css-extract-plugin
export default {"frame":"postcards_frame__3kk78","slides":"postcards_slides__34QSy","slide":"postcards_slide__2j5VH","image":"postcards_image__1K3lM","credits":"postcards_credits__1yWQc"};